import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import styled from 'styled-components';

const ProductItem = styled.div`
	border: 1px solid lightgrey;
	margin-bottom: 8px;
	background-color: white;
	border-radius: 4px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

const IconContainer = styled.div`
	height: 60px;
	display: flex;
	align-items: center;
	margin-right: 6px;
	padding: 0 4px;
`;

const ImageContainer = styled.div`
	margin-right: 8px;
`;

const Image = styled.img`
	width: 35px;
	height: 35px;
	object-fit: contain;
`;

const ProductContent = styled.div`
	display: flex;
	flex-direction: column;
`;
const TitleContainer = styled.div`
	padding: 4px 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 14px;
`;
const SubContentContainer = styled.div`
	padding: 4px 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 11px;
`;

const Product = ({ product, index }) => {
	const { title, id, imageUrl, price, currency } = product;

	return (
		<Draggable draggableId={id} index={index} key={id}>
			{(provided, snapshot) => (
				<ProductItem
					{...provided.draggableProps}
					{...provided.dragHandleProps}
					ref={provided.innerRef}
					isDragging={snapshot.isDragging}
				>
					<IconContainer>
						<DragIndicatorIcon fontSize="small" sx={{ color: '#666666' }} />
					</IconContainer>
					<ImageContainer>
						<Image
							src={imageUrl}
							alt={title}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								currentTarget.src = 'https://via.placeholder.com/300x300';
							}}
						/>
					</ImageContainer>
					<ProductContent>
						<TitleContainer>
							<span>{title}</span>
						</TitleContainer>
						<SubContentContainer>
							{currency} {price}
						</SubContentContainer>
					</ProductContent>
				</ProductItem>
			)}
		</Draggable>
	);
};

export default Product;
